<template>
  <div>
    <Toolbar :handle-update="update">
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.profileparameter.values')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profileparametersetvalue-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.profileparameter.profileparameter') }}</strong></td>
              <td>
                                    {{ item['profileParameter'].name }}
              </td>
              <td><strong>{{ $t('profile.profileparameter.softwareversion') }}</strong></td>
              <td>
                                  <span v-if="item['profileParameter'].softwareVersion">  {{ item['profileParameter'].softwareVersion.name }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.profileparameter.value') }}</strong></td>
              <td>
                                    {{ item['value'] }}
              </td>

              <td><strong>{{ $t('profile.profileparameter.unit') }}</strong></td>
              <td>
                                    {{ item['profileParameter'].Unit }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ProfileParameterSetValue';

export default {
  name: 'ProfileParameterSetValueShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('profileparametersetvalue', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profileparametersetvalue', ['find'])
  },
  methods: {
    ...mapActions('profileparametersetvalue', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
